var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "glitch-image", class: { animations_off: _vm.disabled } },
    [
      _c(
        "div",
        {
          staticClass: "glitch-container",
          class: { active: _vm.shouldGlitch, swapping: _vm.swapLock },
        },
        [
          _c("img", {
            staticClass: "base",
            class: { visible: _vm.activeBase === 0 },
            attrs: {
              src: _vm.baseSrc[0],
              alt: _vm.alt,
              decoding: "async",
              loading: "eager",
            },
          }),
          _c("img", {
            staticClass: "base",
            class: { visible: _vm.activeBase === 1 },
            attrs: {
              src: _vm.baseSrc[1],
              alt: _vm.alt,
              decoding: "async",
              loading: "eager",
            },
          }),
          _c("img", {
            staticClass: "glitch-layer red",
            attrs: {
              src: _vm.renderedSrc,
              alt: "",
              decoding: "async",
              loading: "eager",
            },
          }),
          _c("img", {
            staticClass: "glitch-layer blue",
            attrs: {
              src: _vm.renderedSrc,
              alt: "",
              decoding: "async",
              loading: "eager",
            },
          }),
          _c("img", {
            staticClass: "glitch-layer green",
            attrs: {
              src: _vm.renderedSrc,
              alt: "",
              decoding: "async",
              loading: "eager",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }